import script from "./OtherTalentContainer.vue?vue&type=script&lang=ts"
export * from "./OtherTalentContainer.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__